import type { Ref } from "vue";
import { useHeadlessCultureListState } from "../states/headlessStates";
import type { CultureDto } from "../types";

export function useCultureList (): Ref<CultureDto[] | null> {
  return useHeadlessCultureListState();
}
